import { VSelectItem } from "@/core/interfaces/v-select.interface";
import { DoctorEducation } from "@/core/references/doctor-educations/doctor-education.interface";
import { AxiosInstance } from "axios";

export class DoctorEducationsReference {
  #list: DoctorEducation[] = [];

  constructor(private http: AxiosInstance) {}

  async getList(): Promise<DoctorEducation[]> {
    if (this.#list.length > 0) {
      return this.#list;
    }

    try {
      const { data } = await this.http.get("/v1/references/doctor-educations");
      this.#list = data?.data || [];

      return this.#list;
    } catch (e) {
      console.log(e.response);
    }

    return [];
  }

  async getSelectItems(): Promise<VSelectItem[]> {
    if (!this.#list.length) {
      await this.getList();
    }

    return this.#list.map((item) => ({
      text: item.name,
      value: item.id,
    }));
  }
}
